module.exports = __webpack_public_path__ + "static/media/customerMini.71325770.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/app-composer/concierge/images/customerMini.png
// module id = 598
// module chunks = 0